import { useLang } from 'hooks/lang';

import { Column, Label, RadioInput } from 'components/Blocks';
import { ProjectInvoiceDiscount } from 'entities';

export interface DiscountRequestTypeSelectProps {
  type: ProjectInvoiceDiscount['type'] | '';

  salesDefined?: boolean;
  addSalesDefinedOption?: boolean;

  update: (v: {
    salesDefined?: boolean;
    value?: string;
    percentage?: string;
    type: ProjectInvoiceDiscount['type'];
  }) => void;
}

export function DiscountRequestTypeSelect({
  type,
  update,
  salesDefined,
  addSalesDefinedOption,
}: DiscountRequestTypeSelectProps) {
  const { t } = useLang();

  return (
    <Column gap="2">
      <Label>{t('discount-type')}</Label>

      <RadioInput
        value={salesDefined && addSalesDefinedOption ? 'SALES_DEFINED' : type}
        onChangeDirect={(newType) =>
          newType === 'SALES_DEFINED'
            ? update({ type: type || 'PERCENTAGE', salesDefined: true, value: '', percentage: '' })
            : update({ type: newType as ProjectInvoiceDiscount['type'], salesDefined: false })
        }
        orientation="horizontal"
        addDot={false}
        className="w-full flex-1 rounded-md border px-2 py-1 text-sm"
        selectedClassName="border-primary text-primary"
        containerClassName="small_tablet:flex-col"
        options={[
          { value: 'PERCENTAGE', label: `${t('percentage')} %` },
          { value: 'VALUE', label: `${t('value')} $` },
          { value: 'SALES_DEFINED', label: t('sales-defined'), hide: !addSalesDefinedOption },
        ].filter((o) => !o.hide)}
      />
    </Column>
  );
}
